<template>
  <div>
    <div />
  </div>
</template>

<script>
export default {
  name: 'VbBills',
  components: {},
}
</script>
